import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import Loading from './components/Loading';
import ErrorPage from './pages/ErrorPage';
import { GlobalToastContainer } from './components/Toast/toast';

// Lazy load Cricket Conversation
const CricketConversation = lazy(() => import('./pages/Cricket/Conversation'));

/**
 * CricketApp - Standalone Cricket application
 * No authentication required, separate from main app
 */
const CricketApp: React.FC = () => {
  return (
    <Sentry.ErrorBoundary
      showDialog
      fallback={({ error, resetError }) => (
        <ErrorPage error={error} resetErrorBoundary={resetError} />
      )}
    >
      <main className="h-full">
        <GlobalToastContainer />
        <Suspense fallback={<Loading />}>
          <Routes>
            {/* Cricket app - always at /cricket */}
            <Route path="/cricket" element={<CricketConversation />} />
            {/* Root and all other paths redirect to /cricket */}
            <Route path="/" element={<Navigate to="/cricket" replace />} />
            <Route path="*" element={<Navigate to="/cricket" replace />} />
          </Routes>
        </Suspense>
      </main>
    </Sentry.ErrorBoundary>
  );
};

export default CricketApp;
